// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "notes-" + "commons" + ".js?v=" + "01b2424e6c962e19270e" + "";
};